import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
  DatastoreCountriesModule,
  DatastoreReferralInvitationCheckModule,
  DatastoreUsersSelfModule,
} from '@freelancer/datastore/collections';
import { PipesModule } from '@freelancer/pipes';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { GiveBannedComponent } from './give-banned/give-banned.component';
import { GiveCopyLinkComponent } from './give-desktop/give-copy-link/give-copy-link.component';
import { GiveDesktopProgressBarComponent } from './give-desktop/give-desktop-progress-bar/give-desktop-progress-bar.component';
import { GiveDesktopComponent } from './give-desktop/give-desktop.component';
import {
  GiveFaqExpandableComponent,
  GiveFaqExpandableHeaderComponent,
} from './give-desktop/give-faq/give-faq-expandable/give-faq-expandable.components';
import { GiveFaqComponent } from './give-desktop/give-faq/give-faq.component';
import { GiveHeroComponent } from './give-desktop/give-hero/give-hero.component';
import { GiveHowItWorksComponent } from './give-desktop/give-how-it-works/give-how-it-works.component';
import { GiveShareComponent } from './give-desktop/give-share/give-share.component';
import { GiveUnlockedCreditComponent } from './give-desktop/give-unlocked-credit/give-unlocked-credit.component';
import { GiveGetReferComponent } from './give-get-refer/give-get-refer.component';
import { GiveGetReferralListModalModule } from './give-get-referral-list/give-get-referral-list-modal/give-get-referral-list-modal.module';
import { GiveGetReferralListModule } from './give-get-referral-list/give-get-referral-list.module';
import { GiveGetStatsComponent } from './give-get-stats/give-get-stats.component';
import { GiveMobileComponent } from './give-mobile/give-mobile.component';
import { GiveNotEligibleComponent } from './give-not-eligible/give-not-eligible.component';
import { GiveVerifyComponent } from './give-verify/give-verify.component';
import { GiveComponent } from './give.component';

@NgModule({
  imports: [
    CommonModule,
    GiveGetReferralListModule,
    GiveGetReferralListModalModule,
    MatTooltipModule,
    UiModule,
    PipesModule,
    TrackingModule,
    DatastoreCountriesModule,
    DatastoreUsersSelfModule,
    DatastoreReferralInvitationCheckModule,
  ],
  declarations: [
    GiveComponent,
    GiveFaqComponent,
    GiveFaqExpandableHeaderComponent,
    GiveFaqExpandableComponent,
    GiveGetReferComponent,
    GiveGetStatsComponent,
    GiveDesktopComponent,
    GiveDesktopProgressBarComponent,
    GiveHeroComponent,
    GiveCopyLinkComponent,
    GiveHowItWorksComponent,
    GiveMobileComponent,
    GiveShareComponent,
    GiveUnlockedCreditComponent,
    GiveVerifyComponent,
    GiveBannedComponent,
    GiveNotEligibleComponent,
  ],
  exports: [GiveComponent],
})
export class GiveSharedModule {}
